export const campaignsSimulationsOptions = [
    {label: 'Simulações SEM PROPOSTAS', value: 1}, 
    { label: 'Simulações COM PROPOSTAS', value: 2 }
]